export default __webpack_public_path__ + "static/media/profile.9767d906.svg";